import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { ForgotPasswordParams } from '@/shared/api/requests/account/forgot-password/request';
import { forgotPassword } from '@/shared/api/requests/account/forgot-password/request';

export const useForgotPasswordMutation = (
  settings?: MutationSettings<ForgotPasswordParams, typeof forgotPassword>
) =>
  useMutation({
    mutationKey: ['forgotPassword'],
    mutationFn: ({ params, config }) => forgotPassword({ params, config }),
    ...settings?.options
  });
